import { render } from "./RecenteArticle.vue?vue&type=template&id=49b8df4d"
import script from "./RecenteArticle.vue?vue&type=script&lang=js"
export * from "./RecenteArticle.vue?vue&type=script&lang=js"

import "./RecenteArticle.vue?vue&type=style&index=0&id=49b8df4d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__